// extracted by mini-css-extract-plugin
export default {"scaffold":"l_footer_d_scaffold__uWLvd","f20w700white":"l_footer_d_f20w700white__gCyCL","f18w700white":"l_footer_d_f18w700white__Za2Du","f16w400grey":"l_footer_d_f16w400grey__hTUwa"};